if (!customElements.get('rtl-minimum-order')) {
  class RTLMinimumOrder extends HTMLElement {
    static pendingCartRequest = null;

    connectedCallback() {
      this.minimum = Number(this.dataset.minimumOrder) || 10000;
      this.currency = this.dataset.currency || 'BRL';
      this.locale = this.dataset.locale || 'pt-BR';
      this.update(Number(this.dataset.cartTotal) || 0);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshFromCart());
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    async refreshFromCart() {
      if (!RTLMinimumOrder.pendingCartRequest) {
        RTLMinimumOrder.pendingCartRequest = fetch(`${routes.cart_url}.json`)
          .then((response) => response.json())
          .finally(() => {
            RTLMinimumOrder.pendingCartRequest = null;
          });
      }

      try {
        const cart = await RTLMinimumOrder.pendingCartRequest;
        if (cart?.currency) this.currency = cart.currency;
        this.update(Number(cart?.total_price) || 0);
      } catch (error) {
        console.error('Não foi possível atualizar o aviso de pedido mínimo.', error);
      }
    }

    update(total) {
      this.dataset.cartTotal = total;

      const remaining = Math.max(this.minimum - total, 0);
      const isComplete = total >= this.minimum;
      const progress = this.minimum > 0 ? Math.min((total / this.minimum) * 100, 100) : 100;

      this.hidden = total <= 0;
      this.classList.toggle('is-complete', isComplete);
      this.classList.toggle('is-pending', !isComplete);

      const icon = this.querySelector('.rtl-minimum-order__icon');
      const title = this.querySelector('.rtl-minimum-order__title');
      const message = this.querySelector('.rtl-minimum-order__message');
      const progressElement = this.querySelector('.rtl-minimum-order__track');
      const bar = this.querySelector('.rtl-minimum-order__bar');

      if (icon) icon.textContent = isComplete ? '✓' : 'R$';
      if (title) {
        title.textContent = isComplete
          ? 'Pedido mínimo atingido'
          : `Pedido mínimo de ${this.formatMoney(this.minimum)}`;
      }
      if (message) {
        if (isComplete) {
          message.textContent = 'Tudo certo! Seu pedido já pode ser finalizado.';
        } else {
          message.replaceChildren(
            document.createTextNode('Faltam '),
            Object.assign(document.createElement('strong'), { textContent: this.formatMoney(remaining) }),
            document.createTextNode('. Adicione mais produtos ao carrinho para continuar.')
          );
        }
      }
      if (progressElement) progressElement.setAttribute('aria-valuenow', Math.round(progress));
      if (bar) bar.style.width = `${progress}%`;

      this.updateCheckoutControls(isComplete && total > 0);
    }

    updateCheckoutControls(canCheckout) {
      const context =
        this.closest('cart-notification') ||
        this.closest('cart-drawer') ||
        this.closest('#main-cart-footer') ||
        this.parentElement;

      if (!context) return;

      context.classList.toggle('rtl-minimum-not-met', !canCheckout);
      context.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
        button.disabled = !canCheckout;
        button.setAttribute('aria-disabled', String(!canCheckout));
      });
      context.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach((element) => {
        element.hidden = !canCheckout;
      });
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
        }).format(cents / 100);
      } catch (error) {
        return `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
      }
    }
  }

  customElements.define('rtl-minimum-order', RTLMinimumOrder);
}
